import { Component, OnInit, ViewChild, ElementRef, Sanitizer, SecurityContext } from '@angular/core';

import { ModalComponent } from '../modal-component';


@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent extends ModalComponent<void> implements OnInit {

  public message: string;
  public title: string;
  @ViewChild('confirmButton')
  public confirmButton: ElementRef;
  @ViewChild('denyButton')
  public denyButton: ElementRef;
  private lastActiveElement: any;

  constructor(
    private sanitizer: Sanitizer
  ) {
    super();
  }

  ngOnInit() {
    this.lastActiveElement = document.activeElement;

    setTimeout(() => {
      this.denyButton.nativeElement.focus();
    });
  }

  public setMessage(message: string): void {
    this.message = this.sanitizer.sanitize(SecurityContext.HTML, message);
  }

  public setTitle(title: string): void {
    this.title = title;
  }

  public close() {
    super.close();
 
    if (this.lastActiveElement) {
      this.lastActiveElement.focus();
    }
  }

}
